import styles from "./ServicioTecnicoDomicilio.module.css";

import { useContext, useState, useEffect } from "react";
import {
    Col,
    Row,
    Card,
    Button,
    Modal,
    Form,
    InputGroup,
    FormControl,
    FormLabel,
    FormGroup,
    Alert,
} from "react-bootstrap";

import {
    builtSolicitudDeServicio,
    SolicitudDeServicio,
    builtContratacionServicios,
    ContratacionServicios,
    AltaSolicitudDeServicio_Entrada,
    builtAltaSolicitudDeServicio_Entrada,
    AltaSolicitudDeServicio_Parametros,
    AltaSolicitudDeServicio_Respuesta,
} from "../Commons/Services/AltaSolicitudDeServicioRest";

import Loading from "../General/Loading";
import ConfirmMessage from "../General/ConfirmMessage";

import {
    builtSetReportesEntrada,
    SetReportes_Entrada,
    SetReportes_Parametros,
    SetReportes_Respuesta,
} from "../Commons/Services/SetReportes";
import { ConsultaWS } from "../Commons/ServiciosBase";
import ContextFlujos from "../Context/ContextFlujos";
import { builtRegistrarQuejaRest_Entrada, Queja, RegistrarQuejaRest_Entrada, RegistrarQuejaRest_Parametros, RegistrarQuejaRest_Respuesta } from "../Commons/Services/RegistrarQuejaRest";
import { builtRegistrarSugerenciaRest_Entrada, RegistrarSugerenciaRest_Entrada, RegistrarSugerenciaRest_Parametros, RegistrarSugerenciaRest_Respuesta, Sugerencia } from "../Commons/Services/RegistrarSugerenciaRest";
import HistorialServicioTecCambioDom from "./HistorialServicioTecCambioDom/HistorialServicioTecCambioDom";




const ServicioTecnicoDomicilio = () => {

    const bigText =
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.";
    const maxtLength = 100;
    const [count, setCount] = useState(0);
    const [show, setShow] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [showAlertError, setShowAlertError] = useState(false);
    const [errorAlertMessage, setErrorAlertMessage] = useState("");


    const [descripcionReparacion, setDescripcionReparacion] = useState("");
    const [descripcionCambioDom, setDescripcionCambioDom] = useState("");
    const [status, setStatus] = useState("OK");
    const [message, setMessage] = useState("");
    const [loading, isLoading] = useState(false);
    const [isDisabled, setIsDisabled] = useState(false);
    const [flujo, setFlujo] = useState(sessionStorage.getItem("flujos"));
    const { setReportesHist } = useContext(ContextFlujos) as any;

    const [validaDescripcion, setValidaDescripcion] = useState(false);
    const [validaMotivoLong, setValidaMotivoLong] = useState(false);
    const [validaDescripcionLong, setValidaDescripcionLong] = useState(false);
    const [desactiva, setDesactiva] = useState(false);


    const doSolicitudDeServicio = async (tipoServicio: string) => {
        isLoading(true);
        setIsDisabled(true);

        const SoiciturServicioRest: SolicitudDeServicio =
            builtSolicitudDeServicio(
                `${sessionStorage.getItem("cuenta")}`,
                "Reparaciones",
                "Servicio Web",
                tipoServicio === "reparacion" ? descripcionReparacion : descripcionCambioDom,
                "",
                `${sessionStorage.getItem("RowIdContacto")}`,
                `${sessionStorage.getItem("EmailNotif")}`, //l_MailConfirmacion: string,
                `${sessionStorage.getItem("pais")}`, //l_Pais: string,
                `${sessionStorage.getItem("TipoCuenta")}`, //l_TipoCuenta: string,
                `${sessionStorage.getItem("NombreSuscriptor")}`, //l_NombreSuscriptor: string,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                "HIJUMP",
                `${sessionStorage.getItem("idSesion")}`
            );


        const AltaSolicitudDeServicioDO: AltaSolicitudDeServicio_Entrada =
            builtAltaSolicitudDeServicio_Entrada(SoiciturServicioRest);
        let par = AltaSolicitudDeServicio_Parametros(AltaSolicitudDeServicioDO);
        let AltaSolicitudDeServicioRespuesta: AltaSolicitudDeServicio_Respuesta =
            await ConsultaWS(par);

        if (AltaSolicitudDeServicioRespuesta &&
            AltaSolicitudDeServicioRespuesta.resultado === "0" &&
            AltaSolicitudDeServicioRespuesta.resultadodesc ===
            "0") {
            isLoading(false);
            setStatus("OK");
            setMessage("Su solicitud ha sido recibida : " + AltaSolicitudDeServicioRespuesta.NumeroSolicitud);
            setShowAlert(true);
            setTimeout(() => {
                setShowAlert(false);
            }, 3000);
        } else {
            isLoading(false);
            setStatus("ERROR");
            setMessage("Error " + AltaSolicitudDeServicioRespuesta.resultado + " :" + AltaSolicitudDeServicioRespuesta.resultadodesc);
            setShowAlert(true);
            setTimeout(() => {
                setShowAlert(false);
            }, 3000);

        }

        //----------------------------------------------------------------------------------------------------------------------------
    };


    const handleClose = () => {
        setShow(false);
    };

    const aviso = (status: string, mensaje: string) => {
        setStatus(status);
        if (status == "Error") {
            setErrorAlertMessage(mensaje);
            setShowAlertError(true);
            setTimeout(() => {
                setShowAlertError(false);
            }, 3000);
        } else {
            setMessage(mensaje);
            setShowAlert(true);
            setTimeout(() => {
                setShowAlert(false);
            }, 3000);
        }
    };

    const handleSubmit = (tipoServicio: string) => {

        if (tipoServicio ==="reparacion"){
            if (descripcionReparacion !== "") {
                setShow(true);
                doSolicitudDeServicio(tipoServicio);
            } else {
                aviso("ERROR", "Llene la descripción de la solicitud de reparación ");
            }

        }

        if (tipoServicio ==="domicilio"){
            if (descripcionCambioDom !== "") {
                setShow(true);
                doSolicitudDeServicio(tipoServicio);
            } else {
                aviso("ERROR", "Llenar la descripción de la solicitud de cambio de domicilio");
            }

        }



    };

    function handleDisabled() {
        if (descripcionReparacion) {
            return false;
        } else {
            return false;  /*para que no cambie de color false*/
        }
    }



    const valida = (e: any, campo: string) => {

        let regExLetras = /^(?!\s)[A-Za-zñáéíóúÁÉÍÓÚ\s]+$/; //solo para letras y espacios


        if (campo === "descripcion") {
            setDescripcionReparacion(e);
            e.length === 100 ? setValidaDescripcionLong(true) : setValidaDescripcionLong(false);
            regExLetras.test(e) === false ? setValidaDescripcion(true) : setValidaDescripcion(false);
        }

        if (campo === "descripcionDom") {
            setDescripcionCambioDom(e);
            e.length === 100 ? setValidaDescripcionLong(true) : setValidaDescripcionLong(false);
            regExLetras.test(e) === false ? setValidaDescripcion(true) : setValidaDescripcion(false);
        }


    }



    return (<>
        <Loading isLoading={loading} />
        <Row className={styles["alertContainer"]}>
            <Col className={styles["messageStyle"]}>
                <ConfirmMessage status={status} message={message} showAlert={showAlert} />
            </Col>
        </Row>

        <Row className={styles["headerRow"]}>
            <Col>
                <span className={styles["spectrum"]}>Solicitud de reparación de equipo</span>
            </Col>
        </Row>

        <Row className={styles["subheaderRowTitle"]}>
            <Col>
                <p className={styles["subtitle"]}>
                    Déjanos toda la información de tu reporte del servicio para poder
                    resolverlo.
                </p>
            </Col>
        </Row>

        <Row className={styles["subheaderRow"]}>
            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                <Form className={styles["form"]}>
                    <Form.Group
                        className="mb-3"
                        controlId="aclaracionesForm.descripcionTextarea"
                    >
                        <Form.Label><span className={styles.asterisco}>*{' '}</span>Descripción
                            {/*validaDescripcion ? <span className={styles.asterisco}>{' '}(Sólo texto)</span> : <span></span>*/}
                            {descripcionReparacion.length > 100 ? <span className={styles.asterisco}>{' '}(Máximo 100 carácteres)</span> : <span></span>}
                        </Form.Label>
                        <Form.Control maxLength={200} as="textarea" rows={3} onChange={(e) => valida(e.target.value, "descripcion")} value={descripcionReparacion}
                            style={{ resize: 'none' }} />
                    </Form.Group>
                </Form>
            </Col>
        </Row>
        <Row className={styles["subheaderRow"] + " " + styles["textAreaCounter"]}>
            <Col xs={11} sm={11} md={11} lg={11} xl={11} />
            <Col xs={1} sm={1} md={1} lg={1} xl={1}>
                <p className={styles["textAreaCounter"]}>
                    {descripcionReparacion.length}/{maxtLength}
                </p>
            </Col>
        </Row>
        <Row className={styles["subheaderRowCampos"]}>
            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                <p className={styles["subtitle"]}>
                    <span className={styles.asterisco}>*{' '}</span>Campos obligatorios
                </p>
            </Col>
        </Row>
        <Row className={styles["subheaderRowCampos"]}>
            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                <Button
                    variant="primary"
                    type="submit"
                    className={styles.button}
                    disabled={handleDisabled()}
                    onClick={
                        (e) => handleSubmit("reparacion")}
                >
                    <div className="botonreportar">Enviar Solicitud</div>
                </Button>
            </Col>
        </Row>

        <HistorialServicioTecCambioDom/>


        <Row className={styles["headerRow"]}>
            <Col>
                <span className={styles["spectrum"]}>Solicitud de cambio de domicilio</span>
            </Col>
        </Row>

        <Row className={styles["subheaderRowTitle"]}>
            <Col>
                <p className={styles["subtitle"]}>
                    Llena y envía la solicitud de cambio de domicilio con la fecha y hora deseada,
                    para que un ejecutivo Sky pueda gestionar la visita de un técnico y el traslado de tu equipo.
                </p>
            </Col>
        </Row>

        <Row className={styles["subheaderRow"]}>
            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                <Form className={styles["form"]}>
                    <Form.Group
                        className="mb-3"
                        controlId="aclaracionesForm.descripcionTextarea"
                    >
                        <Form.Label><span className={styles.asterisco}>*{' '}</span>Descripción
                            {/*validaDescripcion ? <span className={styles.asterisco}>{' '}(Sólo texto)</span> : <span></span>*/}
                            {descripcionCambioDom.length > 100 ? <span className={styles.asterisco}>{' '}(Máximo 100 carácteres)</span> : <span></span>}
                        </Form.Label>
                        <Form.Control maxLength={200} as="textarea" rows={3} onChange={(e) => valida(e.target.value, "descripcionDom")} value={descripcionCambioDom}
                            style={{ resize: 'none' }} />
                    </Form.Group>
                </Form>
            </Col>
        </Row>
        <Row className={styles["subheaderRow"] + " " + styles["textAreaCounter"]}>
            <Col xs={11} sm={11} md={11} lg={11} xl={11} />
            <Col xs={1} sm={1} md={1} lg={1} xl={1}>
                <p className={styles["textAreaCounter"]}>
                    {descripcionCambioDom.length}/{maxtLength}
                </p>
            </Col>
        </Row>
        <Row className={styles["subheaderRowCampos"]}>
            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                <p className={styles["subtitle"]}>
                    <span className={styles.asterisco}>*{' '}</span>Campos obligatorios
                </p>
            </Col>
        </Row>
        <Row className={styles["subheaderRowCampos"]}>
            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                <Button
                    variant="primary"
                    type="submit"
                    className={styles.button}
                    disabled={handleDisabled()}
                    onClick={
                        (e) => handleSubmit("domicilio")}
                >
                    <div className="botonreportar">Enviar Solicitud</div>
                </Button>
            </Col>
        </Row>


    </>);

};


export default ServicioTecnicoDomicilio;